import { useState } from "react";
import { Check, Copy } from "lucide-react";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

export function CopyLinkButton({ value, label = "Copy link", testid = "copy-link-btn", className = "" }) {
    const [done, setDone] = useState(false);
    async function copy() {
        try {
            await navigator.clipboard.writeText(value);
            setDone(true);
            toast.success("Copied");
            setTimeout(() => setDone(false), 1800);
        } catch {
            toast.error("Could not copy");
        }
    }
    return (
        <Button
            type="button"
            variant="outline"
            size="sm"
            className={className}
            onClick={copy}
            data-testid={testid}
        >
            {done ? <Check className="mr-1.5 h-3.5 w-3.5" /> : <Copy className="mr-1.5 h-3.5 w-3.5" />}
            {done ? "Copied" : label}
        </Button>
    );
}
